import { render } from "./TaxesView.vue?vue&type=template&id=278f27d3"
import script from "./TaxesView.vue?vue&type=script&lang=js"
export * from "./TaxesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__